import React, { useState } from 'react';
import { Box, Flex, Button, Input, Tag, TagLabel, TagCloseButton, Text } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { TEXT_INPUT_FIELD_STYLES } from '../../modules/administration/accountParameter/constants';

import { useSettingsDisabled } from '../../modules/administration/appyhereParameter/SettingsDisabledContext';

interface StringArrayInputProps {
  value: string[];
  itemKey: string;
  onValueChange: (key: string, newValue: string[]) => void;
  error?: string;
}

export const StringArrayInput: React.FC<StringArrayInputProps> = ({ value, itemKey, onValueChange, error }) => {
  const { t } = useTranslation('common');
  const [localInput, setLocalInput] = useState('');
  const isDisabled = useSettingsDisabled();

  const handleAdd = () => {
    const newId = localInput.trim();
    if (newId) {
      const newArray = [...value, newId];
      onValueChange(itemKey, newArray);
      setLocalInput('');
    }
  };

  const handleRemove = (indexToRemove: number) => {
    const newArray = value.filter((_, i) => i !== indexToRemove);
    onValueChange(itemKey, newArray);
  };

  return (
    <Box>
      <Flex wrap="wrap" mb={2}>
        {value.map((tag, index) => (
          <Tag key={tag} size="lg" borderRadius="full" variant="subtle" colorScheme="blue" mr={2} mb={2}>
            <TagLabel>{tag}</TagLabel>
            <TagCloseButton onClick={() => handleRemove(index)} isDisabled={isDisabled} />
          </Tag>
        ))}
      </Flex>
      <Flex>
        <Input
          key={itemKey}
          placeholder={t('stringArrayInput.placeholder')}
          value={localInput}
          onChange={(e) => setLocalInput(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleAdd();
            }
          }}
          isInvalid={!!error}
          isDisabled={isDisabled}
          {...TEXT_INPUT_FIELD_STYLES}
          maxW="360px"
        />
        <Button ml={2} onClick={handleAdd} isDisabled={!localInput.trim() || isDisabled}>
          {t('stringArrayInput.add')}
        </Button>
      </Flex>
      {error && (
        <Text color="red.500" fontSize="xs" mt={1}>
          {error}
        </Text>
      )}
    </Box>
  );
};
